/* eslint-disable camelcase */
import Vue from 'vue'
import gql from 'graphql-tag'
import createGraphQLClient from '@utils/graphql'

let graphqlClient = null

export const state = {
    objects: {},
    currentVehicle: {},
    currentVehicleAttributes: {},
    currentVehicleRun: {},
    vehiclesTyreLogs: {},
    vehicleTyreLogs: {},
    vehicleServiceLogs: {},
}

export const getters = {}

export const mutations = {
    SET_VEHICLES(state, objects) {
        let updatedObjects = {}
        for (let key in objects) {
            if (!objects[key].deleted_at) {
                // Remove the '__typename' field that gets added by GraphQL
                delete objects[key].__typename
                // Stage the update so we can just do one Vue.set
                updatedObjects[objects[key].id] = objects[key]
            } else if (state.objects.hasOwnProperty(objects[key].id)) {
                // Immediately delete the object
                Vue.delete(state.objects, objects[key].id)
            }
        }
        state.objects = {
            ...updatedObjects,
        }
    },
    SET_VEHICLERUNS(state, objects) {
        let updatedObjects = {}
        for (let key in objects) {
            if (!objects[key].deleted_at) {
                // Remove the '__typename' field that gets added by GraphQL
                delete objects[key].__typename
                // Stage the update so we can just do one Vue.set
                updatedObjects[objects[key].id] = objects[key]
            } else if (state.objects.hasOwnProperty(objects[key].id)) {
                // Immediately delete the object
                Vue.delete(state.objects, objects[key].id)
            }
        }
        state.objects = {
            ...updatedObjects,
        }
    },
    SET_VEHICLE(state, objects) {
      state.currentVehicle = objects
    },
    SET_VEHICLE_ATTRIBUTES(state, objects) {
      state.currentVehicleAttributes = objects
    },
    SET_VEHICLES_TYRELOGS(state, objects) {
      state.vehiclesTyreLogs = objects
    },
    SET_VEHICLE_TYRELOGS(state, objects) {
      state.vehicleTyreLogs = objects
    },
    SET_VEHICLE_SERVICE_LOGS(state, objects) {
      state.vehicleServiceLogs = objects
    },
    SET_VEHICLERUN(state, objects) {
      state.currentVehicleRun = objects
    }
}

export const actions = {
    init({ commit, rootState }) {
        // Initialise the GraphQL client
        graphqlClient = createGraphQLClient(rootState)
    },

    async getVehicles({ commit }) {
        try {
            return await
                graphqlClient.query({
                    query: gql`
                  query getVehicles{
                    vehicles {
                      id
                      number_plate
                      capacity
                      bins {
                        id
                        itemcode
                      }
                      last_known_lat
                      last_known_lon
                      active
                      vehicle_trip_info{
                        id
                        litres
                        fuel_cost
                        mileage
                        number_plate  
                        created_at                      
                      }
                      vehicle_registration_expiry
                      created_at
                      deleted_at
                      updated_at
                    }
                  }
                `,
            }).then((response) => {
              // response.data.vehicles.forEach(vehicle=>vehicle.vehicle_registration_expiry = moment(parseInt(vehicle.vehicle_registration_expiry)).format('DD/MM/YYYY'))
              commit('SET_VEHICLES', response.data.vehicles);
              return response.data.vehicles;
            })
        } catch (ex) {
            console.error(ex)
            throw ex
        }
    },

    async getVehicleById({ commit }, { id } = {}) {
        try {
            return await graphqlClient.query({
                query: gql`
                  query getVehicleById($vid: ID!){
                    vehicleById(id: $vid) {
                      id
                      number_plate
                      capacity
                      vehicle_registration_expiry
                      bins {
                        id
                        itemcode
                      }
                      vehicle_trip_info {
                        id
                        driver_name
                        fuel_location
                        litres
                        fuel_cost
                        tip_cost
                        tip_location
                        tip_weight
                        tip_tonnes
                        mileage
                        tip_docket_number
                        created_at
                      }
                      depot{
                        id
                      }
                      active
                      created_at
                      deleted_at
                      updated_at
                    }
                  }
                `,
                variables:{ vid: id }
            }).then((response)=>{
              commit('SET_VEHICLE', response.data.vehicleById)
              return response.data.vehicleById
            })
        } catch (ex) {
            console.error(ex)
            throw ex
        }
    },

    // async getVehicleFuelConsumptionId({ commit }, { id } = {}) {
    //   try {
    //     return await graphqlClient.query({
    //       query: gql`
    //                 query getVehicleById($vid: ID!){
    //                   vehicleById(id: $vid) {
    //                     id
    //                     number_plate
    //                     capacity
    //                     created_at
    //                     deleted_at
    //                     updated_at
    //                   }
    //                 }
    //               `,
    //       variables:{ vid: id }
    //     }).then((response)=>{
    //       commit('SET_VEHICLE', response.data.vehicleById)
    //       return response.data.vehicleById
    //     })
    //   } catch (ex) {
    //     console.error(ex)
    //     throw ex
    //   }
    // },
    async getVehicleByNumberPlate({ commit }, { numberPlate } = {}) {
        try {
            const response = await graphqlClient.query({
                query: gql`
                  query getVehicleByNumberPlate($plate: String!){
                    vehicleByNumberPlate(number_plate: $plate) {
                      id
                      number_plate
                      capacity
                      depot {
                        id
                      }
                      bins {
                        id
                        itemcode
                      }
                      created_at
                      deleted_at
                      updated_at
                    }
                  }
                `,
                variables:{ plate: numberPlate }
            })
            commit('SET_VEHICLE', response.data.vehicleById)
        } catch (ex) {
            console.error(ex)
            throw ex
        }
    },

    async createVehicle({ commit, dispatch }, {numberPlate, capacity, binIds, depotId, regoExpiry} = {}) {
        try {
          // console.log(regoExpiry)
            await graphqlClient.mutate({
                mutation: gql`
                mutation CreateVehicle($Plate: String $Capacity: Float $Bins: [ID] $Depot: ID $Rego: String)  {
                  createVehicle(vehicle:{number_plate:$Plate capacity:$Capacity bin_ids:$Bins depot_id: $Depot vehicle_registration_expiry: $Rego}) {
                    id
                  }
                }
                `,
                variables: { Plate: numberPlate, Capacity: capacity, Bins : binIds, Depot: depotId, Rego: regoExpiry},
            })
            dispatch('getVehicles')
        } catch (ex) {
            console.error(ex)
            throw ex
        }
    },

    async createVehicleCheckList({ commit }, {username, numberPlate, lights, tyres, indicators, mileage} = {}) {
        try {
            await graphqlClient.mutate({
                mutation: gql`
                mutation createVehicleCheck($Username: String $Plate: String $Lights: Boolean $Indicators: Boolean $Tyres: Boolean $Mileage: Int)  {
                  createVehicleCheck(
                    vehiclecheck:{
                      username: $Username
                      number_plate: $Plate
                      lights: $Lights
                      tyres: $Tyres
                      indicators: $Indicators
                      mileage: $Mileage
                    }
                  ) {
                    id
                  }
                }
                `,
                variables: { Plate: numberPlate, Username: username, Lights: lights, Tyres: tyres, Indicators: indicators, Mileage: mileage},
            }).then((res) => {
              // console.log(res)
            })
        } catch (ex) {
            console.error(ex)
            throw ex
        }
    },

    async updateVehicle({ commit, dispatch }, {id, numberPlate, capacity, binIds, depotId, status, regoExpiry} = {}) {
        try {
            return await graphqlClient.mutate({
                mutation: gql`
                mutation UpdateVehicle($vid:Int! $Plate: String $Capacity: Float $Bins: [ID] $Depot: ID $Status: Boolean $Rego: String)  {
                  updateVehicle(id: $vid vehicle:{number_plate:$Plate capacity:$Capacity bin_ids:$Bins depot_id: $Depot active: $Status vehicle_registration_expiry: $Rego}) {
                    id
                  }
                }
                `,
                variables: { vid: id, Plate: numberPlate, Capacity: capacity, Bins : binIds, Depot: depotId, Status: status, Rego: regoExpiry},
            }).then((response) => {
              commit('SET_VEHICLE', response.data.updateVehicle)
              dispatch('getVehicles')
            })
        } catch (ex) {
            console.error(ex)
            throw ex
        }
    },
    async deleteVehicle({ commit }, {id} = {}) {
        try {
            const response = await graphqlClient.mutate({
                mutation: gql`
                mutation DeleteVehicle($vid:Int!)  {
                  deleteVehicle(id: $vid) {
                    id
                  }
                }
                `,
                variables: { vid: id},
            })
            commit('SET_VEHICLES', response.data.deleteVehicle)

        } catch (ex) {
            console.error(ex)
            throw ex
        }
    },
    async createVehicleRun({ commit, dispatch }, {description, timestamp, lat, lon, vehicleId} = {}) {
        try {
            // let that = this
            await graphqlClient.mutate({
                mutation: gql`
                mutation createVehicleRun($Description: String $Timestamp: String $Lat: Float $Lon: Float $Vehicle: ID)  {
                  createVehicleRun(run_input:{description: $Description timestamp: $Timestamp lat: $Lat lon: $Lon vehicle_id: $Vehicle}) {
                    id
                  }
                }
                `,
                variables: { Description: description, Timestamp: timestamp, Lat: lat, Lon: lon, Vehicle: vehicleId },
            })
        } catch (ex) {
            console.error(ex)
            throw ex
        }
    },
    async vehicleRunByVehicleId({ commit }, { id , date} = {}) {
        try {
            const response = await graphqlClient.query({
                query: gql`
                  query vehicleRunByVehicleId($Id: ID! $Date: String){
                    vehicleRunByVehicleId(vehicle_id: $Id date: $Date) {
                      id
                      vehicle_id
                      description
                      timestamp
                      lat
                      lon
                      created_at
                      deleted_at
                      updated_at
                    }
                  }
                `,
                variables:{ Id: id, Date: date }
            })
            commit('SET_VEHICLERUN', response.data.vehicleRunByVehicleId)
        } catch (ex) {
            console.error(ex)
            throw ex
        }
    },

    async getVehicleTyreLogs({ commit }) {
      try {
        return await graphqlClient.query({
          query: gql`
              query vehicleTyreLogs{
                  vehicleTyreLogs{
                    id
                    vehicle{
                      id,
                      number_plate,                    
                    }
                    driver{
                      id,
                      name,                      
                    }                    
                    date,
                    fitter_signature,
                    mileage,
                    order_number,
                    additional_comments,
                    repair_reasons,
                    tyres,
                  }
                }
              `,
        }).then((response) => {
          // // console.log(response)
          commit('SET_VEHICLES_TYRELOGS', response.data.vehicleTyreLogs);
          return response.data.vehicleTyreLogs;
        })
      } catch (ex) {
        console.error(ex)
        throw ex
      }
    },

    async getVehicleTyreLogsByVehicleId({ commit }, { id } = {}) {
      try {
        return await graphqlClient.query({
          query: gql`
            query vehicleTyreLogsByVehicleId($Id: ID!){
              vehicleTyreLogsByVehicleId(vehicle_id: $Id) {
                id
                vehicle{
                  id,
                  number_plate,                    
                }
                driver{
                  id,
                  name,                      
                }                    
                date,
                fitter_signature,
                mileage,
                order_number,
                additional_comments,
                repair_reasons,
                tyres,
                created_at,
                deleted_at,
                updated_at,
              }
            }
          `,
          variables:{ Id: id }
        }).then((response) => {
          // console.log(response)
          commit('SET_VEHICLE_TYRELOGS', response.data.vehicleTyreLogsByVehicleId);
          return response.data.vehicleTyreLogsByVehicleId;
        })
      } catch (ex) {
        console.error(ex)
        throw ex
      }
    },

    async getMechanicsChecklistByRego({ commit }, { rego } = {}) {
      try {
        return await graphqlClient.query({
          query: gql`
            query mechanicsChecklistByRego($Rego: String!){
              mechanicsChecklistByRego(truck_rego: $Rego) {
                id
                additionalNotes,
                mechanicsLicense,
                mechanicsName,
                serviceHours,
                serviceNumber,
                truckKm,
                truckRego,
                truckType,
                axelLH,
                axelRH,
                bodyChecklist,
                engineCompartmentChecklist,
                inCabChecklist,
                truckExternalChecklist,
                underVehicleChecklist,
                signature_url,
                vehicle {
                  id,
                }
                created_at,
                deleted_at,
                updated_at,
              }
            }
          `,
          variables:{ Rego: rego }
        }).then((response) => {
          // console.log(response)
          commit('SET_VEHICLE_SERVICE_LOGS', response.data.mechanicsChecklistByRego);
          return response.data.mechanicsChecklistByRego;
        })
      } catch (ex) {
        console.error(ex)
        throw ex
      }
    },

}
